import EmersonLogoSVGComponent from "./EmersonLogo";
import HipaaCompliantPrimarySVGComponent from "./footer/HipaaCompliantPrimary";
import HipaaCompliantWhiteSVGComponent from "./footer/HipaaCompliantWhite";
import SecureCheckoutPrimarySVGComponent from "./footer/SecureCheckoutPrimary";
import SecureCheckoutWhiteSVGComponent from "./footer/SecureCheckoutWhite";
import SvgFullscriptLogoDarkGreenWhiteComponent from "./FullscriptLogoDarkGreenWhite";
import FullscriptLogoDarkTextGreenLeafSVGComponent from "./FullscriptLogoDarkTextGreenLeaf";
import FullscriptLogoLeafSVGComponent from "./FullscriptLogoLeaf";
import FullscriptLogoLeafDarkSVGComponent from "./FullscriptLogoLeafDark";
import FullscriptLogoWhiteTextGreenLeafSVGComponent from "./FullscriptLogoWhiteTextGreenLeaf";
import NovaLogoSVGComponent from "./NovaLogo";
import NovaLogoIconSVGComponent from "./NovaLogoIcon";
import NovaLogoTextSVGComponent from "./NovaLogoText";
import PoweredByFullscriptSVGComponent from "./PoweredByFullscript";
import PoweredByFullscriptDarkSVGComponent from "./PoweredByFullscriptDark";
import RupaLogoSvgComponent from "./RupaLogo";
import RupaMigrateArrowSVGComponent from "./RupaMigrateArrow";
import WellevateByFullscript from "./wellevate-by-fullscript.png";

const SvgEmersonLogo = EmersonLogoSVGComponent;
const SvgFullscriptLogoDarkGreenWhite = SvgFullscriptLogoDarkGreenWhiteComponent;
const SvgFullscriptIcon = FullscriptLogoLeafSVGComponent;
const SvgRupaIcon = RupaLogoSvgComponent;
const SvgRupaMigrateArrow = RupaMigrateArrowSVGComponent;
const SvgFullscriptIconDarkGreen = FullscriptLogoLeafDarkSVGComponent;
const SvgFullscriptLogo = FullscriptLogoWhiteTextGreenLeafSVGComponent;
const SvgFullscriptLogoDarkTextGreenLeaf = FullscriptLogoDarkTextGreenLeafSVGComponent;
const SvgNovaLogo = NovaLogoSVGComponent;
const SvgNovaLogoIcon = NovaLogoIconSVGComponent;
const SvgNovaLogoText = NovaLogoTextSVGComponent;
const SvgHipaaLogoPrimary = HipaaCompliantPrimarySVGComponent;
const SvgHipaaLogoWhite = HipaaCompliantWhiteSVGComponent;
const SvgSecureCheckoutPrimary = SecureCheckoutPrimarySVGComponent;
const SvgSecureCheckoutWhite = SecureCheckoutWhiteSVGComponent;
const SvgPoweredByFullscript = PoweredByFullscriptSVGComponent;
const SvgPoweredByFullscriptDark = PoweredByFullscriptDarkSVGComponent;

export {
  SvgEmersonLogo,
  SvgFullscriptLogoDarkGreenWhite,
  SvgFullscriptIcon,
  SvgRupaIcon,
  SvgRupaMigrateArrow,
  SvgFullscriptIconDarkGreen,
  SvgFullscriptLogo,
  SvgFullscriptLogoDarkTextGreenLeaf,
  SvgNovaLogo,
  SvgNovaLogoIcon,
  SvgNovaLogoText,
  SvgHipaaLogoPrimary,
  SvgHipaaLogoWhite,
  SvgSecureCheckoutPrimary,
  SvgSecureCheckoutWhite,
  WellevateByFullscript,
  SvgPoweredByFullscript,
  SvgPoweredByFullscriptDark,
};
